@if (conceptNavEnabled$ | async) {
  <div class="concept-navigator-container" data-automation-id="concept-navigator" role="navigation" aria-label="Concept">
    <!-- PREV Concept -->
    <button
      data-automation-id="concept-nav-previous-button"
      mhe-button
      class="btn-arrow-icon"
      [purpose]="ButtonPurpose.Icon"
      [mheTooltip]="'concept-navigator.button_previous' | translate"
      placement="right"
      [disabled]="prevButtonDisabled$ | async"
      (click)="onPrevBtnClicked()"
      >
      <i class="dpg-icon dpg-icon-up-arrow"></i>
    </button>
    <!-- SKIP to current concept -->
    <span class="current-concept-container">
      <button
        data-automation-id="concept-nav-current-button"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="'concept-navigator.button_current' | translate"
        placement="right"
        [disabled]="currentButtonDisabled$ | async"
        (click)="onCurBtnClicked()"
        >
        <i class="dpg-icon dpg-icon-system-library"></i>
      </button>
    </span>
    <!-- NEXT Concept -->
    <button
      data-automation-id="concept-nav-next-button"
      mhe-button
      class="btn-arrow-icon"
      [purpose]="ButtonPurpose.Icon"
      [mheTooltip]="'concept-navigator.button_next' | translate"
      placement="right"
      [disabled]="nextButtonDisabled$ | async"
      (click)="onNextBtnClicked()"
      >
      <i class="dpg-icon dpg-icon-down-arrow"></i>
    </button>
  </div>
}
